import 'expo-dev-client';

// eslint-disable-next-line no-restricted-exports
export { default } from './app/Main';
